import React from 'react';
import { useActions, useAppSelector, HollowOutGuideAction } from '@web-common/state/createStore';
import styles from './imgBubbleGuide.module.scss';
import { getIn18Text } from 'api';
const HasMaskFooter = props => {
    const { guideId, step, onStep, okText = getIn18Text('ZHIDAOLE'), onClose } = props;
    const onGuide = useAppSelector(state => state.hollowOutGuideReducer.guideQueue[0]);
    const { doNextStep, doSkip } = useActions(HollowOutGuideAction);
    const handleNext = () => {
        doNextStep({ step: onStep, guideId });
        onClose && onClose();
    };
    const handleSkip = () => {
        doSkip({ guideId });
        onClose && onClose();
    };
    return (React.createElement("div", { className: styles.footer },
        step ? (React.createElement("span", null,
            onStep,
            "/", onGuide === null || onGuide === void 0 ? void 0 :
            onGuide.steps.length)) : (React.createElement("span", null)),
        React.createElement("div", { className: styles.footerRight },
            (onGuide === null || onGuide === void 0 ? void 0 : onGuide.steps.length) > 2 && (React.createElement("span", { className: styles.skip, onClick: handleSkip }, getIn18Text('TIAOGUO'))),
            React.createElement("button", { className: styles.butt, onClick: handleNext }, onStep >= (onGuide === null || onGuide === void 0 ? void 0 : onGuide.steps.length) ? okText : getIn18Text('XIAYIBU')))));
};
export default HasMaskFooter;
